/* ============================================================
   category.js — Collection page filter/sort bar interactions.

   The static build's version of this file fetched catalog.json and
   collections.json and built the ENTIRE product grid from scratch
   client-side (titles, descriptions, pagination, sorting). On Shopify
   all of that is real, server-rendered by sections/main-collection.liquid
   (real collection.products, real pagination, real native `sort_by`).
   This file's remaining real job: the mobile filter bottom-sheet
   open/close, and live client-side availability/price filtering over
   the cards Liquid already rendered (no Search & Discovery filter app
   is installed on the store, so this is a real, working client-side
   approximation rather than a server-side filter — sort and pagination
   are the parts that are genuinely server-real).
   ============================================================ */
(function () {
  "use strict";

  var grid = document.querySelector("[data-grid]");
  if (!grid) return;

  var sheet = document.querySelector("[data-sheet]");
  var sheetToggle = document.querySelector("[data-filter-open]");
  var sheetClose = document.querySelector("[data-filter-close]");
  var backdrop = document.querySelector("[data-filter-backdrop]");
  var availBoxes = Array.prototype.slice.call(document.querySelectorAll("[data-avail]"));
  var priceMinEl = document.querySelector("[data-price-min]");
  var priceMaxEl = document.querySelector("[data-price-max]");
  var filterCountEl = document.querySelector("[data-filter-count]");
  var emptyEl = document.querySelector("[data-empty]");
  var countLine = document.querySelector("[data-count-line]");

  var mqMobile = window.matchMedia("(max-width: 767px)");
  function isMobile() { return mqMobile.matches; }

  function openSheet() {
    if (!isMobile() || !sheet) return;
    sheet.setAttribute("data-open", "");
    if (backdrop) backdrop.setAttribute("data-open", "");
    if (sheetToggle) sheetToggle.setAttribute("aria-expanded", "true");
    if (window.__ghoncheLockPageScroll) window.__ghoncheLockPageScroll(true);
  }

  function closeSheet() {
    var wasOpen = !!(sheet && sheet.hasAttribute("data-open"));
    if (sheet) sheet.removeAttribute("data-open");
    if (backdrop) backdrop.removeAttribute("data-open");
    if (sheetToggle) sheetToggle.setAttribute("aria-expanded", "false");
    if (wasOpen && window.__ghoncheLockPageScroll) window.__ghoncheLockPageScroll(false);
  }

  if (sheetToggle) sheetToggle.addEventListener("click", openSheet);
  if (sheetClose) sheetClose.addEventListener("click", closeSheet);
  if (backdrop) backdrop.addEventListener("click", closeSheet);
  window.addEventListener("resize", function () { if (!isMobile()) closeSheet(); });

  /* ---------- Live client-side availability/price filter ---------- */
  var cards = Array.prototype.slice.call(grid.querySelectorAll(".card"));

  function cardIsAvailable(card) {
    var addBtn = card.querySelector("[data-quick-add]");
    return !(addBtn && addBtn.disabled);
  }

  function cardPrice(card) {
    var addBtn = card.querySelector("[data-quick-add]");
    return addBtn ? Number(addBtn.dataset.price) / 100 : null;
  }

  function applyFilters() {
    var showIn = availBoxes.length ? availBoxes.some(function (b) { return b.value === "in" && b.checked; }) : true;
    var showOut = availBoxes.length ? availBoxes.some(function (b) { return b.value === "out" && b.checked; }) : true;
    var min = priceMinEl && priceMinEl.value !== "" ? Number(priceMinEl.value) : null;
    var max = priceMaxEl && priceMaxEl.value !== "" ? Number(priceMaxEl.value) : null;

    var visibleCount = 0;
    cards.forEach(function (card) {
      var available = cardIsAvailable(card);
      var price = cardPrice(card);
      var matchesAvail = available ? showIn : showOut;
      var matchesPrice = (min == null || price == null || price >= min) && (max == null || price == null || price <= max);
      var visible = matchesAvail && matchesPrice;
      card.style.display = visible ? "" : "none";
      if (visible) visibleCount++;
    });

    if (emptyEl) emptyEl.hidden = visibleCount > 0;
    if (countLine) countLine.textContent = visibleCount + (visibleCount === 1 ? " product" : " products");

    var activeCount = (availBoxes.length && !(showIn && showOut) ? 1 : 0) + (min != null || max != null ? 1 : 0);
    if (filterCountEl) {
      filterCountEl.hidden = activeCount === 0;
      filterCountEl.textContent = activeCount;
    }
  }

  availBoxes.forEach(function (box) { box.addEventListener("change", applyFilters); });
  var priceTimer = null;
  [priceMinEl, priceMaxEl].forEach(function (el) {
    if (!el) return;
    el.addEventListener("input", function () {
      clearTimeout(priceTimer);
      priceTimer = setTimeout(applyFilters, 300);
    });
  });

  var applyBtn = document.querySelector("[data-filter-apply]");
  if (applyBtn) applyBtn.addEventListener("click", function (e) {
    e.preventDefault();
    applyFilters();
    closeSheet();
  });

  var resetBtn = document.querySelector("[data-filter-reset]");
  if (resetBtn) resetBtn.addEventListener("click", function (e) {
    if (resetBtn.tagName === "A") return; // real link to the clean collection URL
    e.preventDefault();
    availBoxes.forEach(function (b) { b.checked = true; });
    if (priceMinEl) priceMinEl.value = "";
    if (priceMaxEl) priceMaxEl.value = "";
    applyFilters();
  });
})();
